import { getGeneralEventData } from "//gunner.com/cdn/shop/t/611/assets/data-capture_get-event-data.js?v=70177412789918390081717746100";
import { sendDataEvent } from "//gunner.com/cdn/shop/t/611/assets/data-capture_send-event.js?v=89369398181597458251717752096";

const eventPingIntervalMs = 10000;
let generalEventDataJson = JSON.stringify(getGeneralEventData());

const dataCapturePing = setInterval(() => {
  const newGeneralEventData = getGeneralEventData();
  const newGeneralEventDataJson = JSON.stringify(newGeneralEventData);

  // If the general event data has been updated, send an event.
  if (generalEventDataJson !== newGeneralEventDataJson && document.visibilityState === 'visible') {
    const uniqueEventData = {
      'event_name': 'ping'
    };
    sendDataEvent(uniqueEventData, newGeneralEventData);
    generalEventDataJson = newGeneralEventDataJson;
  }
}, eventPingIntervalMs);